
module.exports = {
  address: '0xf3AE5d769e153Ef72b4e3591aC004E89F48107a1',
  address_test: '0xcc90dB72166FB7703F124f6a33F70aE0Ed27F1d0',
  abi: require('./DPR.abi.json')
}
